export default __webpack_public_path__ + "static/Supreme-Bold-4329eb89d30734394c05086de34022c4.woff";